import React, { Component } from 'react';
import "./input.css";
import anime from 'animejs';

import FlatUIButton from './flat-ui-button.js';

class SingleSelect extends Component {
  easing = 'easeOutQuad'
  state = {
    selected: null,
    submitted: false
  }
  additional_data = { selections: [], meta: { rendered: performance.now() } }

  getId(option) {
    return this.props.id + "-option_" + this.props.options.indexOf(option)
  }

  primaryColor() {
    return "#e71272";
    // const computedStyles = getComputedStyle(document.body)
    // return computedStyles.getPropertyValue('--primary').trim()
  }

  unselectedOptionTargets(option) {
    return this.props.options
      .filter(opt => opt !== option)
      .map(opt => "#" + this.getId(opt))
  }

  onSelected(event, option) {
    if (this.props.inputDisabled || this.state.submitted) return

    // console.log(option, this.getId(option), this.unselectedOptionTargets(option))
    let timestamp = performance.now()
    if (!this.additional_data.interaction_delay_time) {
      this.additional_data.interaction_delay_time = timestamp - this.additional_data.meta.rendered
    }
    if (this.additional_data.meta.last_interaction) this.additional_data.selections.push((timestamp - this.additional_data.meta.last_interaction).toString())
    this.additional_data.meta.last_interaction = timestamp

    let selection = this.state.selected === option ? null : option

    this.setState({
      selected: selection
    })

    if (selection) {
      this.additional_data.selections.push(option)
    } else {
      this.additional_data.selections.push("UNSELECTED: " + option)
    }

    if (!this.props.requireValidation && !this.props.isStatic) {
      this.onSubmit(event, option)
    } else if (this.props.isStatic) {
      this.props.addMessage(selection)
    }
  }


  onSubmit(event, option) {
    // console.log(option, this.getId(option), this.unselectedOptionTargets(option))

    this.setState({ submitted: true })

    let timestamp = performance.now()
    this.additional_data.submission_delay_time = timestamp - this.additional_data.meta.last_interaction

    let anim = anime.timeline()

    const el = document.getElementById(this.getId(option));
    let computedStyles = window.getComputedStyle(el, null)
    const lineHeight = parseFloat(computedStyles.getPropertyValue('line-height'))
    // const primary = computedStyles.getPropertyValue('--primary').trim()
    //const shadow = "rgba(0, 0, 0, 0.2) 0px 1px 1px 0px;" //computedStyles.getPropertyPriority('--shadow-1').trim()
    const isMultiline = el.firstChild.offsetHeight > lineHeight

    const innerWidth = el.firstChild.offsetWidth + 1
    const whiteSpaceWidth = (el.firstChild.offsetLeft) * 2 // padding
    const newWidth = isMultiline ? el.offsetWidth : innerWidth + whiteSpaceWidth

    const animateWidth = Math.abs(newWidth - el.offsetWidth) > 4
    const width = animateWidth ? newWidth : el.offsetWidth

    const newOffset = (el.offsetLeft - el.parentNode.offsetLeft) + (el.offsetWidth - width) / 2

    const desiredOffset = el.parentNode.clientWidth - width

    // console.log(el.parentNode.clientWidth, el.offsetWidth, newWidth, desiredOffset, newOffset, el.offsetLeft, el.parentNode.offsetLeft)
    // console.log(el.offsetTop)

    const duration = 600
    anim
      .add({
        targets: [".submit-button", ...this.unselectedOptionTargets(option)],
        opacity: 0,
        duration: duration / 2,
        easing: this.easing,
        offset: 0,
      })
      .add({
        targets: "#" + this.getId(option),
        translateX: desiredOffset - newOffset + "px",
        translateY: -1 * (el.offsetTop - el.parentNode.offsetTop) + "px",
        width: animateWidth ? width : null,
        offsetLeft: el.offsetLeft,
        duration: duration,
        easing: this.easing,
        offset: 0,
        complete: anim => {
          this.props.addMessage(option, this.additional_data)
        }
      })
      .add({
        targets: "#" + this.getId(option),
        backgroundColor: ["#e71272", "#008DD5"],
        boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 2px 0px",
        duration: 150,
        offset: 0,
        easing: this.easing
      })
  }

  render() {
    // console.log(this.props)
    const rootClasses = (!this.props.isStatic ? "input" : "") + 
      (this.props.inputDisabled ? " input-disabled" : "") + 
      (this.props.compact ? " compact" : "")
    let extraContainerClasses = this.props.options.length > 4 ? "select-many-choices" : "select-few-choices";
    if (this.props.longAnswers) {
      extraContainerClasses += " stacked"
    }
    let buttons = this.props.options.map(opt => {
      return (
        <FlatUIButton key={opt}
            variant="raised" 
          outline longAnswer={this.props.longAnswers} centeredAnswer={this.props.centeredAnswers}
            className={this.state.selected === opt ? 'primary' : ''}
            id={this.getId(opt)} 
            onClick={e => this.onSelected(e, opt)}>
          {opt}
        </FlatUIButton>
      )
    })

    return (
      <div className={rootClasses}>
        {/*<p className="input-tip">
          { this.props.options.length > 1 ? "Choose an option" : "Click to continue" }
        </p>*/}
        <div className={extraContainerClasses}>
          { buttons }
        </div>
        { this.props.requireValidation && 
          <div className="centered submit-container">
            <FlatUIButton disabled={!this.state.selected} className="rounded primary submit-button" 
                onClick={e => this.onSubmit(e, this.state.selected)}>
              OK
            </FlatUIButton>
          </div>
        }
      </div>
    )
    
  }
}

export default SingleSelect;


// WEBPACK FOOTER //
// ./src/components/input/single.js